export default __webpack_public_path__ + "static/media/video_desktop.918806ad.mp4";